import * as graphql from '@treams/treams-network';
import { WorkspacePlanV2 } from '@treams/treams-network';

import { useWorkspace } from './useWorkspace';

type WorkspaceConfiguration = {
	data?: {
		redirect?: string;
		startDate?: string;
		singleSignOns?: { url: string }[];
		supportedLanguageIDs?: string[];
		plans: WorkspacePlanV2[];
		connector?: string;
	};
	loading: boolean;
};

export function useWorkspaceConfiguration(): WorkspaceConfiguration {
	const { data, loading } = graphql.useWorkspaceConfigurationQuery({
		variables: {
			id: useWorkspace().id,
		},
		nextFetchPolicy: 'cache-first',
	});

	if (loading) {
		return { loading };
	}

	if (!data) {
		return { data: undefined, loading: false };
	}

	return {
		data: {
			redirect: data?.workspace.redirect ?? undefined,
			startDate: data?.workspace.startDate,
			supportedLanguageIDs: data?.workspace.supportedLanguageIDs,
			singleSignOns: data?.singleSignOns,
			plans: data?.workspace.plans ?? [],
		},
		loading: false,
	};
}
